import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { SOCIAL_MEDIA_LABELS, SOCIAL_MEDIA_PLACEHOLDERS } from '@/utils';
import Icon from '@/components/Icon';
import Button from '@/components/Button';
import Popover from '@/components/Popover';
import Form from '@/components/Form';
import LoadingButton from '@/components/LoadingButton';
import FormField from '@/components/FormField';
import { TextInput } from '@/components/Inputs';

const propTypes = {
  onEditContact: PropTypes.func,
  contact: PropTypes.object
};

const defaultProps = {
  onEditContact: () => {},
  contact: {}
};

/* eslint-disable no-magic-numbers */
const schema = Yup.object().shape({
  contact: Yup.object().shape({
    facebook: Yup.string()
      .max(255, 'Facebook deve ter no máximo 255 caracteres'),
    twitter: Yup.string()
      .max(255, 'Twitter deve ter no máximo 255 caracteres'),
    linkedin: Yup.string()
      .max(255, 'LinkedIn deve ter no máximo 255 caracteres'),
    instagram: Yup.string()
      .max(255, 'Instagram deve ter no máximo 255 caracteres'),
    skype: Yup.string()
      .max(255, 'Skype deve ter no máximo 255 caracteres')
  })
});
/* eslint-enable no-magic-numbers */

function getContactAttributes(contact = {}) {
  return {
    contact: {
      facebook: contact.facebook ?? '',
      linkedin: contact.linkedin ?? '',
      instagram: contact.instagram ?? '',
      skype: contact.skype ?? '',
      twitter: contact.twitter ?? ''
    }
  };
}

function SocialMediaPopoverFull({ onEditContact, contact }) {
  const initialValues = getContactAttributes(contact);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const handleSubmitSocialMedia = (values, onHide, setSubmitting) => {
    const updatedFields = Object.keys(values.contact)
      .reduce((obj, key) => {
        if (values.contact[key] !== contact[key]) {
          obj.contact = { ...obj.contact, [key]: values.contact[key] };
        }
        return obj;
      }, {});

    onEditContact(updatedFields, () => {
      setSubmitting(false);
      onHide();
    });
  };

  return (
    <Popover
      placement='left'
      showArrow
      show={isPopoverOpen}
      onHide={() => setIsPopoverOpen(false)}
      content={({ onHide }) => (
        <div className='py-4 d-flex flex-column'>
          <h4 className='mb-4'>Redes Sociais</h4>
          <Form
            name='social-media-full-form'
            validationSchema={schema}
            initialValues={initialValues}
            onSubmit={(
              values,
              { setSubmitting }
            ) => handleSubmitSocialMedia(values, onHide, setSubmitting)}
          >
            {({ isSubmitting }) => (
              <>
                <FormField
                  name='contact.facebook'
                  as={TextInput}
                  label={SOCIAL_MEDIA_LABELS.facebook}
                  placeholder={SOCIAL_MEDIA_PLACEHOLDERS.facebook}
                  maxLength={255}
                />
                <FormField
                  name='contact.twitter'
                  as={TextInput}
                  label={SOCIAL_MEDIA_LABELS.twitter}
                  placeholder={SOCIAL_MEDIA_PLACEHOLDERS.twitter}
                  maxLength={255}
                />
                <FormField
                  name='contact.linkedin'
                  as={TextInput}
                  label={SOCIAL_MEDIA_LABELS.linkedin}
                  placeholder={SOCIAL_MEDIA_PLACEHOLDERS.linkedin}
                  maxLength={255}
                />
                <FormField
                  name='contact.skype'
                  as={TextInput}
                  label={SOCIAL_MEDIA_LABELS.skype}
                  placeholder={SOCIAL_MEDIA_PLACEHOLDERS.skype}
                  maxLength={255}
                />
                <FormField
                  name='contact.instagram'
                  as={TextInput}
                  label={SOCIAL_MEDIA_LABELS.instagram}
                  placeholder={SOCIAL_MEDIA_PLACEHOLDERS.instagram}
                  maxLength={255}
                />
                <div className='d-flex justify-content-end mt-2 gap-2'>
                  <Button
                    variant='link'
                    onClick={onHide}
                    className='fw-bold'
                  >
                    Cancelar
                  </Button>
                  <LoadingButton
                    variant='primary'
                    isLoading={isSubmitting}
                    type='submit'
                  >
                    Salvar
                  </LoadingButton>
                </div>
              </>
            )}
          </Form>
        </div>
      )}
    >
      <div className='d-inline-block'>
        <Button
          id='edit-social-media-button'
          variant='lighter-blue'
          size='sm'
          className='p-2 bg-gray-100 rounded-full ms-auto'
          onClick={() => setIsPopoverOpen(true)}
        >
          <Icon name='edit' className='text-primary' />
        </Button>
      </div>
    </Popover>
  );
}

SocialMediaPopoverFull.propTypes = propTypes;
SocialMediaPopoverFull.defaultProps = defaultProps;

export default SocialMediaPopoverFull;
